module.exports = __webpack_public_path__ + "res/img_usage_type_employee.7543f3787cadd0507f645f6a2be90ce1.png";